import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";
import {
  AFFILIATE_BANK_ADD,
  AFFILIATE_BANK_DELETE,
  AFFILIATE_BANK_DETAILE,
  AFFILIATE_BANK_LIST,
  AFFILIATE_BANK_UPDATE,
  AFFILIATE_COMMISSION,
  AFFILIATE_COMMISSION_DETAIL,
  AFFILIATE_LIST,
  AFFILIATE_PRODUCTS,
  AFFILIATE_WITHDRAW,
  AFFILIATE_WITHDRAW_ADD,
  AFFILIATE_WITHDRAW_DETAIL,
  AFFILIATE_WITHDRAW_UPDATE,
  AFFILIATELINK_ADD,
  CREATE_AFFILIATE,
  CURRENT_AFFILIATE,
  DELETE_AFFILIATE,
  DETAIL_AFFILIATE,
  UPDATE_AFFILIATE,
  UPDATE_STATUS_AFFILIATE,
} from "../actions/affiliate.actions.types";
import { affiliateSlice } from "../slices/affiliate";

const call = Effects.call;

function* affiliateList({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "affiliates/list",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(
        affiliateSlice.actions.setAffiliateList(result.data?.affilates)
      );
      callback({ success: true, data: result.data });
    }
  }
}

function* affiliateCommission({ payload: { id, data, callback } }) {
  const payload = {
    method: "get",
    url: `commissions/list?affiliateId=${id}`,
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* affiliateWithdraw({ payload: { id, data, callback } }) {
  const payload = {
    method: "get",
    url: `withdrawals/list${id ? `?affiliateId=${id}` : ""}`,
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(
        affiliateSlice.actions.setAffiliateList(result.data?.affilates)
      );
      callback({ success: true, data: result.data });
    }
  }
}
function* affiliateProducts({ payload: { id, data, callback } }) {
  const payload = {
    method: "get",
    url: `affiliate-links/list?affiliateId=${id}`,
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(
        affiliateSlice.actions.setAffiliateList(result.data?.affilates)
      );
      callback({ success: true, data: result.data });
    }
  }
}

function* affiliateBankList({ payload: { id, data, callback } }) {
  const payload = {
    method: "get",
    url: `payout-methods/list?affiliateId=${id}`,
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(
        affiliateSlice.actions.setAffiliateList(result.data?.affilates)
      );
      callback({ success: true, data: result.data });
    }
  }
}

function* createAffiliate({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "affiliates",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });
  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}
function* affiliateWithdrawAdd({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "withdrawals",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });
  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* affiliateLinkAdd({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "affiliate-links",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });
  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* affiliateAddBank({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "payout-methods",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });
  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* currentAffiliate({ payload: { callback } }) {
  const payload = {
    method: "get",
    url: `affiliates/current/`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(
        affiliateSlice.actions.setaffiliate(result.data?.affiliate)
      );
      callback({ success: true, data: result.data });
    }
  }
}

function* detailAffiliate({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `affiliates/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}
function* affiliateDetailBank({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `payout-methods/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}
function* affiliateDeleteBank({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `payout-methods/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}
function* affiliateCommissionDetail({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `commissions/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}
function* affiliateWithdrawDetail({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `withdrawals/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* updateAffiliate({ payload: { id, data, callback, settingPage } }) {
  const payload = {
    method: "put",
    url: `affiliates/${id}`,
    data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      if (settingPage) {
        yield Effects.put(
          affiliateSlice.actions.setaffiliate(result.data?.affiliate)
        );
      }
      callback({ success: true, data: result.data });
    }
  }
}
function* updateStatusAffiliate({ payload: { id, data, callback } }) {
  const payload = {
    method: "put",
    url: `affiliates/status/${id}`,
    data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}
function* affiliateUpdateBank({ payload: { id, data, callback } }) {
  const payload = {
    method: "put",
    url: `payout-methods/${id}`,
    data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* affiliateWithdrawUpdate({ payload: { id, data, callback } }) {
  const payload = {
    method: "put",
    url: `withdrawals/${id}`,
    data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteAffiliate({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `affiliates/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* Affiliates() {
  yield all([takeLatest(CREATE_AFFILIATE, createAffiliate)]);
  yield all([takeLatest(CURRENT_AFFILIATE, currentAffiliate)]);
  yield all([takeLatest(AFFILIATE_LIST, affiliateList)]);
  yield all([takeLatest(AFFILIATELINK_ADD, affiliateLinkAdd)]);
  yield all([takeLatest(AFFILIATE_BANK_ADD, affiliateAddBank)]);
  yield all([takeLatest(AFFILIATE_BANK_UPDATE, affiliateUpdateBank)]);
  yield all([takeLatest(AFFILIATE_BANK_DETAILE, affiliateDetailBank)]);
  yield all([takeLatest(AFFILIATE_BANK_DELETE, affiliateDeleteBank)]);
  yield all([takeLatest(AFFILIATE_PRODUCTS, affiliateProducts)]);
  yield all([takeLatest(AFFILIATE_BANK_LIST, affiliateBankList)]);
  yield all([
    takeLatest(AFFILIATE_COMMISSION_DETAIL, affiliateCommissionDetail),
  ]);
  yield all([takeLatest(AFFILIATE_COMMISSION, affiliateCommission)]);
  yield all([takeLatest(AFFILIATE_WITHDRAW_ADD, affiliateWithdrawAdd)]);
  yield all([takeLatest(AFFILIATE_WITHDRAW_DETAIL, affiliateWithdrawDetail)]);
  yield all([takeLatest(AFFILIATE_WITHDRAW, affiliateWithdraw)]);
  yield all([takeLatest(AFFILIATE_WITHDRAW_UPDATE, affiliateWithdrawUpdate)]);
  yield all([takeLatest(DETAIL_AFFILIATE, detailAffiliate)]);
  yield all([takeLatest(UPDATE_AFFILIATE, updateAffiliate)]);
  yield all([takeLatest(UPDATE_STATUS_AFFILIATE, updateStatusAffiliate)]);
  yield all([takeLatest(DELETE_AFFILIATE, deleteAffiliate)]);
}

export default Affiliates;
